// material-ui

import vcaCertificate from '../../../assets/images/qualifications/vca-certificate.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const VCACertificate = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={vcaCertificate} alt="VCACertificate" height={props.height || 24}  />
    );
};

export default VCACertificate;